import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
} from "react";

interface AnalysisData {
    coreTopic: string;
    subtopicsSkills: string[]
    userIntent: string;
    levelOfDepth: string;
    resourcePreferences: string[];
    userGoal: string;
}

interface GuidedSearchState {
    topic: string;
    subTopics: string[];
    analysis?: AnalysisData;
}

interface GuidedSearchContextState {
    guidedSearch: GuidedSearchState | undefined;
    setGuidedSearch: (guidedSearch: GuidedSearchState) => void;
}

const GuidedSearchContext = createContext<GuidedSearchContextState | undefined>(undefined);

export const GuidedSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [guidedSearch, setGuidedSearch] = useState<GuidedSearchState | undefined>(undefined);

    return (
        <GuidedSearchContext.Provider value={{ guidedSearch, setGuidedSearch }}>
            {children}
        </GuidedSearchContext.Provider>
    )
}

export const useGuidedSearch = (): GuidedSearchContextState => {
    const context = useContext(GuidedSearchContext);
    if (!context) {
        throw new Error("useGuidedSearch must be used within a GuidedSearchProvider");
    }
    return context;
}
